module.exports = __webpack_public_path__ + "img/14.4e482e21.png";